import React from "react";
import { Button } from "../../../components/common/Button";

interface WeekNavigatorProps {
  weekRangeLabel: string;
  onPrev: () => void;
  onNext: () => void;
}

// Navigazione settimana precedente/successiva con etichetta del range.
export const WeekNavigator: React.FC<WeekNavigatorProps> = ({ weekRangeLabel, onPrev, onNext }) => (
  <div className="flex items-center justify-between gap-3">
    <Button variant="secondary" size="sm" onClick={onPrev}>
      ←
    </Button>
    <h1 className="text-xl font-semibold capitalize text-center">{weekRangeLabel}</h1>
    <Button variant="secondary" size="sm" onClick={onNext}>
      →
    </Button>
  </div>
);
